import { render, staticRenderFns } from "./kyc_stage2.vue?vue&type=template&id=172d5b60&"
import script from "./kyc_stage2.vue?vue&type=script&lang=js&"
export * from "./kyc_stage2.vue?vue&type=script&lang=js&"
import style0 from "./kyc_stage2.vue?vue&type=style&index=0&id=172d5b60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports